module.exports = __webpack_public_path__ + "img/bkcc.4f0494b1.png";